export default {"src":"/_next/static/media/history_file_blue.e59979c9.svg","height":16,"width":14};